module.exports = __webpack_public_path__ + "static/media/tomihiro.801ca018.jpg";